<script setup>
import EyeIcon from '@iconify-vue/ph/eye';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import DataTableLayout from '@js/components/tables/DataTableLayout.vue';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import HeaderCell from '@js/components/tables/cells/HeaderCell.vue';
import LinkCell from '@js/components/tables/cells/LinkCell.vue';
import NumberCell from '@js/components/tables/cells/NumberCell.vue';
import TextCell from '@js/components/tables/cells/TextCell.vue';
import { useDataTable } from '@js/utils/dataTable';
import { useRoute } from '@js/utils/route';
import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue';

const { route } = useRoute();

const columnHelper = createColumnHelper();

const {
    loading,
    table,
    count,
    globalFilter,
    setGlobalFilter,
    availableFilters,
    filters,
    setFilters,
} = useDataTable({
    columns: [
        columnHelper.accessor(() => null, {
            id: 'name',
            header: () => 'Nom',
            cell: (props) =>
                h(LinkCell, {
                    text: props.row.original.name,
                    href: route('front.projectManagement.seo.netlinking', {
                        tenant: props.row.original.id,
                    }),
                    inertia: true,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'numberOfBacklinks',
            header: () => 'Nb backlinks',
            cell: (props) =>
                h(NumberCell, {
                    number: props.row.original.numberOfBacklinks,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'numberOfActiveBacklinks',
            header: () => 'Nb backlinks actifs',
            cell: (props) =>
                h(NumberCell, {
                    number: props.row.original.numberOfActiveBacklinks,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'numberOfInactiveBacklinks',
            header: () => 'Nb backlinks inactifs',
            cell: (props) =>
                h(NumberCell, {
                    number: props.row.original.numberOfInactiveBacklinks,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'maxDate',
            header: () => 'Date max',
            cell: (props) =>
                props.row.original.maxDate
                    ? h(TextCell, {
                          text: props.row.original.maxDate,
                      })
                    : null,
        }),
        columnHelper.display({
            id: 'actions',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'Actions',
                    width: 0,
                }),
            cell: (props) =>
                h(
                    BaseCell,
                    {},
                    {
                        default: () =>
                            h(ActionButton, {
                                size: 'small',
                                square: true,
                                title: 'Voir',
                                href: route(
                                    'front.projectManagement.seo.netlinking',
                                    {
                                        tenant: props.row.original.id,
                                    },
                                ),
                                icon: EyeIcon,
                            }),
                    },
                ),
        }),
    ],
    url: route('front.projectManagement.seo.postBacklinks'),
    columnPinning: {
        right: ['actions'],
    },
});
</script>

<template>
    <DataTableLayout
        :table="table"
        :count="count"
        :global-filter="globalFilter"
        :set-global-filter="setGlobalFilter"
        :available-filters="availableFilters"
        :filters="filters"
        :set-filters="setFilters"
        :loading
    />
</template>
